import React from 'react';
export function TableOfContents() {
  const items = ['Die Falle der „Hochdosis“', 'Ein Vorfall, den ich anfangs nicht ernst nahm', 'Der Fehler, den ich damals nicht verstand', 'Winter. Die ersten seltsamen Anzeichen', 'Untersuchung und Diagnose', 'Operation und Ursache', 'Was mir der Arzt erklärte (4 Regeln)', 'Vergleich populärer Formeln', 'Expertenmeinung'];
  return <div className="max-w-3xl mx-auto px-4 mb-12" data-id="element-312">
      <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm" data-id="element-313">
        <h3 className="text-xl font-bold text-[#1B1B2F] mb-4 flex items-center gap-2" data-id="element-314">
          <span className="text-[#2B4C7E]" data-id="element-315">📖</span> Inhaltsverzeichnis
        </h3>
        <nav data-id="element-316">
          <ul className="space-y-3" data-id="element-317">
            {items.map((item, index) => <li key={index} className="flex items-start group cursor-pointer" data-id="element-318">
                <div className="w-1 h-full min-h-[1.5rem] bg-[#2B4C7E] mr-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-319" />
                <span className="text-[#2B4C7E] font-medium hover:underline decoration-[#2B4C7E] decoration-1 underline-offset-4" data-id="element-320">
                  {item}
                </span>
              </li>)}
          </ul>
        </nav>
      </div>
    </div>;
}